<div class="navbar-top fuse-navy-900" style="border-bottom:1px solid black;">
    <a href="javascript:void(0)" [routerLink]="'/apps/dashboard'">
        <div class="logo">
            <img class=" logo-icon" src="assets/images/logos/MIA.png">
            <span class="logo-text secondary-text">AKILLI ATIK SİSTEMİ</span>
        </div>
    </a>


    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container fuse-navy-700" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user fuse-navy-900" fxLayout="column">

        <div class="h2 username">{{userName}}</div>
        <div class="avatar-container fuse-navy-900">
            <div *ngIf="picture!=''">
                <img class="avatar" [src]="appConfigService.apiConfig['api-url']+'user/'+picture">
            </div>
            <div *ngIf="picture==''">
                <mat-icon class="avatar">person</mat-icon>
            </div>
        </div>

    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>